module.exports = __webpack_public_path__ + "static/media/flash-logo.3153fdae.svg";